const Day = ({ day, dayIdx, days, classNames, handleSelect }) => {
    return(
        <button
            key={day.date}
            type="button"
            onClick={() => handleSelect(dayIdx, day.date)}
            className={classNames(
            'py-1.5 hover:bg-secundario hover:text-white focus:z-10',
            day.isCurrentMonth ? 'bg-secundarioMira' : 'bg-primarioMira',
            (day.isSelected || day.isToday) && 'font-semibold',
            day.isSelected && 'text-white font-bold',
            !day.isSelected && day.isCurrentMonth && !day.isToday && 'text-white',
            !day.isSelected && !day.isCurrentMonth && !day.isToday && 'text-grisMira',
            day.isToday && !day.isSelected && 'text-secundario',
            dayIdx === 0 && 'rounded-tl-lg',
            dayIdx === 6 && 'rounded-tr-lg',
            dayIdx === days.length - 7 && 'rounded-bl-lg',
            dayIdx === days.length - 1 && 'rounded-br-lg'
            )}
        >
            <time
            dateTime={day.date}
            className={classNames(
                'mx-auto flex h-7 w-7 items-center justify-center rounded-full',
                day.isSelected && day.isToday && 'bg-secundario',
                day.isSelected && !day.isToday && 'bg-white text-primarioMira'
            )}
            >
            {day.date.split('-').pop().replace(/^0/, '')}
            </time>
        </button>
    )
}

export default Day